import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./FormStyles.css";
import "./UnifiedFormStyles.css";

function MayaBlack({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    maya_black_merchandising_type: false,
    maya_black_merchandising_branding: false,
    location: false,
  });

  const [formData, setFormData] = useState({
    maya_black_merchandising_type: primaryDetails.maya_black_merchandising_type || '',
    maya_black_merchandising_branding: primaryDetails.maya_black_merchandising_branding || '',
    location: primaryDetails.location || '',
  });

  const merchandisingTypeOptions = [
    "Standee",
    "Door Hanger", 
    "Tobleron",
    "Tissue Holder",
    "None"
  ];

  const brandingOptions = [
    "Non Preferred/ Acrylic",
    "Prefered / Metal"
  ];

  const locationOptions = [
    'glass door - eye level',
    'glass door - not eye level',
    'counter',
    'glass window',
    'others'
  ];

  const handleInputChange = (e) => {
  const { name, value } = e.target;
  
  setFormData(prev => ({ ...prev, [name]: value }));
  setPrimaryDetails(prev => ({ ...prev, [name]: value }));

  if (name && isError[name]) {
    setIsError(prev => ({ ...prev, [name]: false }));
  }
};

  const validateForm = () => {
    const errors = {};

    // Always validate merchandising type
    if (!formData.maya_black_merchandising_type) {
      errors.maya_black_merchandising_type = true;
    }

    // Only validate branding and location if merchandising type is NOT "None"
    if (formData.maya_black_merchandising_type !== 'None') {
      if (!formData.maya_black_merchandising_branding) {
        errors.maya_black_merchandising_branding = true;
      }
      if (!formData.location) {
        errors.location = true;
      }
    }

    

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    if (!formData.maya_black_merchandising_type) {
      return false;
    }

    if (formData.maya_black_merchandising_type !== 'None') {
      return !!formData.maya_black_merchandising_branding && !!formData.location;
    }

    return true;
  };

  const handleSubmit = () => {
  if (validateForm()) {
    setPrimaryDetails(prev => ({
      ...prev, 
      maya_black_merchandising_type: formData.maya_black_merchandising_type,
      maya_black_merchandising_branding: formData.maya_black_merchandising_branding,
      location: formData.location,
    }));
    
    navigation.go('interested-maya-solution');
  }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Maya Black</h4>
              <p className="form-desc">Please provide Maya Black merchandising details</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* Merchandising Type */}
                  <Form.Group className="mb-5" controlId="maya_black_merchandising_type">
                    <Form.Label className="form-label">
                      Merchandising Type <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Select
                      name="maya_black_merchandising_type"
                      value={formData.maya_black_merchandising_type || ""}
                      onChange={handleInputChange}
                      className={`form-input${
                        isError.maya_black_merchandising_type ? " form-input-error" : ""
                      }`}
                    >
                      <option value="">Select merchandising type</option>
                      {merchandisingTypeOptions.map((type, index) => (
                        <option key={`merch-type-${index}`} value={type}>
                          {type}
                        </option>
                      ))}
                    </Form.Select>
                    {isError.maya_black_merchandising_type && (
                      <div className="form-error">Please select a merchandising type</div>
                    )}
                  </Form.Group>

                  {/* Branding - Only show when merchandising type is NOT "None" */}
                  {formData.maya_black_merchandising_type !== 'None' && (
                    <Form.Group className="mb-5" controlId="maya_black_merchandising_branding">
                      <Form.Label className="form-label">
                        Branding <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Select
                        name="maya_black_merchandising_branding"
                        value={formData.maya_black_merchandising_branding || ""}
                        onChange={handleInputChange}
                        className={`form-input${
                          isError.maya_black_merchandising_branding ? " form-input-error" : ""
                        }`}
                      >
                        <option value="">Select branding type</option>
                        {brandingOptions.map((branding, index) => (
                          <option key={`branding-${index}`} value={branding}>
                            {branding}
                          </option>
                        ))}
                      </Form.Select>
                      {isError.maya_black_merchandising_branding && (
                        <div className="form-error">Please select a branding type</div>
                      )}
                    </Form.Group>
                  )}

                  {/* Location - Only show when merchandising type is NOT "None" */}
                  {formData.maya_black_merchandising_type !== 'None' && (
                    <Form.Group className="mb-5" controlId="location">
                      <Form.Label className="form-label">
                        Location <span className="form-required">*</span>
                      </Form.Label>
                      <div>
                        {locationOptions.map((location) => (
                          <Form.Check
                            key={location}
                            type="radio"
                            name="location"
                            label={location}
                            value={location}
                            checked={formData.location === location}
                            onChange={handleInputChange}
                            className="form-radio mb-2"
                          />
                        ))}
                      </div>
                      {isError.location && (
                        <div className="form-error">Please select a location</div>
                      )}
                    </Form.Group>
                  )}

                  <div className="form-nav-btns">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleSubmit}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                        Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaBlack;
